/* レスポンスダイアログ */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface Props {
  is_confirm: boolean;
  show: boolean;
  title: string;
  body: string | JSX.Element;
  ClickCallBackYes?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  ClickCallBackNo?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  ClickCallBackConfirm?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const ResponseDialog: React.FC<Props> = ({
  is_confirm,
  show,
  title,
  body,
  ClickCallBackYes,
  ClickCallBackNo,
  ClickCallBackConfirm,
}) => {
  return (
    <Modal size="lg" centered show={show} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title className="dialog-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dialog-body">{body}</Modal.Body>
      <Modal.Footer>
        {is_confirm ? (
          <Button variant="main-color" onClick={ClickCallBackConfirm}>
            確認
          </Button>
        ) : (
          <>
            <Button variant="main-color" onClick={ClickCallBackYes}>
              はい
            </Button>
            <Button variant="main-color" onClick={ClickCallBackNo}>
              いいえ
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ResponseDialog;
